import React, { useMemo } from 'react';
import UserSessionMenu from './UserSessionMenu';
import { AulaNav } from './AulaShell';
import { buildParticularAlumnoMenuItems } from './menus/ParticularAlumnoMenu';
import useMensajesNoLeidos from '../../hooks/useMensajesNoLeidos';
import logoAnimacion from '../../assets/logos/logoAnimacion.png';
import '../AulaPublicPage.css';
import './StudentShell.css';

/**
 * Armazón del espacio del alumno particular (Mi espacio, Calendario, Mensajes).
 * Reutiliza el encabezado y el menú del aula para que todo se vea como un mismo producto.
 */
// Armazón del alumno particular. El preceptor lo reutiliza con su propio menú (buildMenuItems) y etiqueta.
const StudentShell = ({
  activeId,
  onNavigate,
  user,
  onLogout,
  particularName,
  headerActions,
  children,
  buildMenuItems = buildParticularAlumnoMenuItems,
  userFallbackLabel = 'Alumno'
}) => {
  const { count: mensajesNoLeidos } = useMensajesNoLeidos(true, { scope: 'particular' });
  const items = useMemo(() => buildMenuItems().map((item) => ({
    ...item,
    key: item.id,
    icon: item.icon.replace(/^fas\s+/, ''),
    count: item.id === 'mensajes' ? mensajesNoLeidos : undefined
  })), [buildMenuItems, mensajesNoLeidos]);

  return (
    <div className="aula-public-page aula-shell student-shell">
      <header className="aula-public-header">
        <div className="header-brand">
          <img src={logoAnimacion} alt="aluxIA" />
          <div>
            <p>aluxIA</p>
            <span>{particularName}</span>
          </div>
        </div>
        <div className="header-info">
          {headerActions}
          <UserSessionMenu user={user} onLogout={onLogout} userFallbackLabel={userFallbackLabel} />
        </div>
      </header>

      <div className="aula-layout">
        <AulaNav
          items={items}
          active={activeId}
          onSelect={(key) => onNavigate(items.find((item) => item.key === key))}
        />
        <main className="aula-public-content">{children}</main>
      </div>
    </div>
  );
};

export const StudentModal = ({
  eyebrow,
  title,
  subtitle,
  onClose,
  onSubmit,
  footer,
  wide = false,
  closeOnOverlay = true,
  children
}) => {
  const Card = onSubmit ? 'form' : 'div';

  return (
    <div className="consent-overlay" onClick={closeOnOverlay ? onClose : undefined}>
      <Card
        className={`consent-card sp-modal ${wide ? 'wide' : ''}`}
        role="dialog"
        aria-modal="true"
        onSubmit={onSubmit}
        onClick={(event) => event.stopPropagation()}
      >
        <header className="sp-modal-head">
          <div>
            {eyebrow && <span className="sp-modal-eyebrow">{eyebrow}</span>}
            <h3>{title}</h3>
            {subtitle && <p>{subtitle}</p>}
          </div>
          <button type="button" className="sp-modal-close" onClick={onClose} aria-label="Cerrar">
            <i className="fas fa-times" aria-hidden="true" />
          </button>
        </header>
        <div className="sp-modal-body">{children}</div>
        {footer && <footer className="consent-actions">{footer}</footer>}
      </Card>
    </div>
  );
};

export default StudentShell;
